import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Card from "../../components/Reusable/Card";
import ApiDocsInterface from "../../components/ApiDocsInterface/ApiDocsInterface";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

const APIIntegrationComponent = loadable(
  () => import("../../components/APIIntegration"),
);

const APIIntegration = () => {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch("https://apiservice.careinfosolutions.com/?format=openapi")
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        console.log(data);
        setApiData(data);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          API Integration
        </span>
      </div>
      <APIIntegrationComponent />
      <Card title="Documentations">
        <div>
          {loading ? (
            <Loader2 className={tw`w-12 h-12 animate-spin text-red-600 mb-4`} />
          ) : (
            <ApiDocsInterface apiData={apiData} />
          )}
        </div>
      </Card>
    </>
  );
};

export default APIIntegration;
